export { default } from '@shikijs/langs/pug'
